export const CREATE_BOOKING_CLICKED = `CREATE_BOOKING_CLICKED`;
export const CREATE_BOOKING_CANCELLED = `CREATE_BOOKING_CANCELLED`;
export const TRACK_EDIT_BOOKING_TIME_CLICKED = `TRACK_EDIT_BOOKING_TIME_CLICKED`;
export const CREATE_BOOKING_STEPPER_STEP_CHANGED = `CREATE_BOOKING_STEPPER_STEP_CHANGED`;



// WEBPACK FOOTER //
// ./scripts/constants/analytics.js